import {
  PhaseEntityType,
  converToEntityId,
} from 'components/organisms/projects/project-plan/phase-entity';
import { ProjectTemplateApi } from 'data/templates/projects';

export const migrations = {
  addEntityOrderToProjectTemplatePhases: (
    projectTemplate: ProjectTemplateApi,
  ) => {
    if (
      !projectTemplate.templateContent.projectPhases ||
      projectTemplate.templateContent.projectPhases.every(
        (phase) => phase.entityOrder !== undefined,
      )
    ) {
      return projectTemplate;
    }

    const migratedProjectTemplate: ProjectTemplateApi = {
      ...projectTemplate,
      templateContent: {
        ...projectTemplate.templateContent,
        projectPhases:
          projectTemplate.templateContent.projectPhases?.map((phase) => ({
            ...phase,
            entityOrder:
              phase.entityOrder ??
              phase.tasks
                .filter((task) => !task.isNew)
                .map((task) =>
                  converToEntityId(task.taskId, PhaseEntityType.Task),
                ),
          })) ?? [],
      },
    };

    return migratedProjectTemplate;
  },
};
